import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { getDefaultPreviewAppTypeList } from "@uiview/views/PreviewApp/const";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logEvent } from "@uikit/service/amplitude";
import { editorActions } from "../store/editor";
import { fotActions } from "../store/fot";
import { studioActions } from "../store/studio";
import func from "@uikit/func";
import { DEFALUT_PROJECT_NAME, IMAGICA_NEW_PROJECT_ONBOARDING } from "../views/thinking-layout-editor/constants";
import { usePreviewAppStore } from "./HomeUsePluginRoot/usePreviewAppStore";
import useFeatureTags from "./useFeatureTags";
import useFocusNode from "./useFocusNode";

export default function useCreateNewProject({
  showDisableStudiosOnboarding,
  disableCotOnboarding,
  getSimpleNode,
  clickZoomFitIcon,
  clickStep,
  setShowNavPage,
  initNewProjectV2,
  setShowCot,
  emptyNodes,
  setShowPreviewPanel,
}) {
  const dispatch = useDispatch();
  const feature_tags = useFeatureTags();
  const imagicaStudioTutorial = useSelector(state => state.fot.imagicaStudioTutorial);
  const { addPreview, clearCurrentProjectSavedPreviewList } = usePreviewAppStore();
  // const setImagicaStudioTutorial = (val) => {
  //   dispatch(fotActions.setImagicaStudioTutorial(val));
  // };
  const { focusLastNode } = useFocusNode();

  const setDisableAddPreview = val => {
    dispatch(fotActions.setDisableAddPreview(val));
  };
  const setLoadingState = val => {
    dispatch(studioActions.setLoadingState(val));
  };
  // const setTutorialTempProjectData = (val) => { dispatch(editorActions.setTutorialTempProjectData(val)) };
  const setSelectedTemplate = val => {
    dispatch(studioActions.setSelectedTemplate(val));
  };
  const setStudioProjectName = val => {
    dispatch(fotActions.setStudioProjectName(val));
  };
  const setShowTooltip = val => {
    dispatch(editorActions.setShowTooltip(val));
  };
  const setEnableTooltipWhatTodo = val => {
    dispatch(editorActions.setEnableTooltipWhatTodo(val));
  };
  const setSecondInputNodeId = val => {
    dispatch(editorActions.setSecondNodeId(val));
  };

  // const setCurrentGuideTitlePage = (val) => { dispatch(editorActions.setCurrentGuideTitlePage(val)) }
  const {
    nodeIndexRef,
    preferenceJson,
    saasAndThinkState: { firstCreateProjectRef, firstRunEdgeRef },
    newOnboardingFlowState: { openOptTempLateModal, selectedFlowItem, getItemByKeyword },
  } = useHomeUsePluginContainer();

  const navigate = useNavigate();
  // const { setCenter } = useReactFlow();

  const createTemplate = async templateName => {
    const dataVersion = feature_tags.enableNewEdge ? "v3" : "v2";
    const params = {
      // 情况项目名两边多余空格
      template_name: templateName.trim(),
      description: "",
      [dataVersion]: {
        edges: [],
        nodes: [],
        showToolTipStatus: "init", // 初始化 init; 显示 show; 关闭 close；
        nodeIndex: 0,
        edgeIndex: 0,
      },
    };
    // 重置node index
    nodeIndexRef.current = 1;
    setSecondInputNodeId(null);
    // 清空node
    emptyNodes();
    // 保持input展开
    if (feature_tags.disableCotFlowInCanvas === false && !feature_tags.enableNewOnboardingFlow) {
      setShowCot(true);
    } else {
      setShowCot(false);
    }
    // selectedFlowItem.value = {};
    if (feature_tags.enableNewOnboardingFlow) {
      const obj = preferenceJson.value.find(x => x.key === IMAGICA_NEW_PROJECT_ONBOARDING);
      if (obj?.value) {
        const data = typeof obj.value === "string" ? JSON.parse(obj.value) : obj.value;
        openOptTempLateModal.value = !data.dontShowAgain;
        if (data.dontShowAgain) {
          // 勾选了下次不再显示，则默认选择thinkingCanvas
          selectedFlowItem.value = getItemByKeyword("ownFlow", "thinkingCanvas");
        }
      } else {
        openOptTempLateModal.value = true;
      }
    }
    // STUD-1093 tutorial v2 - disableCotOnboarding
    //  自动打开cot 或 打开new onboarding flow时，不初始化第一个node
    if (
      feature_tags.disableCotFlowInCanvas ||
      (typeof initNewProjectV2 === "function" && (!showDisableStudiosOnboarding || imagicaStudioTutorial.viewed))
    ) {
      if (!feature_tags.enableNewOnboardingFlow) {
        // 不要使用save接口初始化project， 改为在调用create时就初始化第一个node
        const initNodes = initNewProjectV2();
        const newNodes = initNodes.map(getSimpleNode);
        params[dataVersion].nodes = newNodes;
      }
    }

    const selectedTemplateObj = _.cloneDeep(params);
    selectedTemplateObj.name = selectedTemplateObj.name || templateName;
    setSelectedTemplate(selectedTemplateObj || {});
    setStudioProjectName(selectedTemplateObj.name);

    navigate(`/editor/${selectedTemplateObj.name}`);
    logEvent("create_project");
  };

  const addNewProject = async () => {
    clearCurrentProjectSavedPreviewList();
    const showTips = await createTemplate(DEFALUT_PROJECT_NAME);
    setEnableTooltipWhatTodo(true);
    // 有 todotip 的节点移动视口到合适的位置
    setTimeout(() => {
      // 居中节点，但是需要减掉 todoTip 的高度
      focusLastNode({ height: -160 });
    }, 200);
    setShowTooltip("editor-1");
    setDisableAddPreview(true);
    setLoadingState({
      promptSaveBtn: false,
      promptNewBtn: false,
      promptCard: false,
    });

    if (func.isEmpty(showTips)) {
      setShowNavPage(false);
    }

    /**
     * 创建Project时
     * 1、自动生成一个AI APP
     * 2、并打开preview页面
     * 3.preview v2版本应自动创建一条app数据
     */
    if (feature_tags.enableAutoCreateAIApp && !feature_tags.enableNewOnboardingFlow) {
      setShowPreviewPanel(true);
      firstCreateProjectRef.current = true;
      firstRunEdgeRef.current = true;
      addPreview({
        format: getDefaultPreviewAppTypeList()[0],
      });
    }
  };
  return {
    addNewProject,
  };
}
